import { fromByteArray, toByteArray } from 'base64-js';
import { downloadBlob } from './download-blob';
import { TextEncoderLite } from 'text-encoder-lite';
import * as saveAs from 'file-saver';
export var FileType;
(function (FileType) {
    FileType["pdf"] = "application/pdf";
    FileType["jpeg"] = "image/jpeg";
    FileType["html"] = "text/html";
    FileType["xlsx"] = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    FileType["kml"] = "application/vnd.google-earth.kml+xml";
    FileType["other"] = "application/octet-stream";
    FileType["gif"] = "image/gif";
    FileType["png"] = "image/png";
    FileType["svg"] = "image/svg+xml";
})(FileType || (FileType = {}));
export function getFileType(filename) {
    if (filename.includes('.pdf'))
        return FileType.pdf;
    if (filename.includes('.jpeg') ||
        filename.includes('.jpg') ||
        filename.includes('.JPEG') ||
        filename.includes('.JPG'))
        return FileType.jpeg;
    if (filename.includes('.html'))
        return FileType.html;
    if (filename.includes('.xlsx'))
        return FileType.xlsx;
    if (filename.includes('.kml'))
        return FileType.kml;
    return FileType.other;
}
function saveToFile(content, filename) {
    const type = getFileType(filename);
    let changed_content = content;
    if (type === FileType.pdf || type === FileType.jpeg) {
        changed_content = toByteArray(content);
    }
    return new Promise((resolve) => 
    // @ts-ignore
    window.requestFileSystem(window.PERSISTENT, 0, (fs) => fs.root.getFile(filename, { create: true }, (file) => file.createWriter(function (writer) {
        writer.onwriteend = () => resolve(file);
        writer.onerror = (e) => console.log('file write error :(', e.toString());
        writer.write(new Blob([changed_content], { type }));
    }))));
}
const openWithFileOpener = async function (content, filename) {
    const file = await saveToFile(content, filename);
    // toByteArray(
    // @ts-ignore
    window.cordova.plugins.fileOpener2.showOpenWithDialog(
    // @ts-ignore
    'cdvfile://localhost/persistent' + file.fullPath, getFileType(filename), {
        success() {
            return console.log('FILEOPENER ok');
        },
        error(e) {
            return console.log(`FILEOPENER err ${e.message}`);
        },
    });
};
const shareWithSocialSharing = async function (content, filename, api, title = 'Отправить или сохранить файл') {
    const file = await saveToFile(content, filename);
    // @ts-ignore
    window.plugins.socialsharing.shareWithOptions({
        // @ts-ignore
        files: [file.toURL()],
        chooserTitle: title,
    }, () => console.log('SOCIALSHARING>>> ok'), (e) => console.log(`SOCIALSHARING>>> error ${e.message}`));
};
function openInNewWindow(content, filename) {
    const type = getFileType(filename);
    if (type === FileType.pdf) {
        downloadBlob(toByteArray(content), filename, type, true);
        return;
    }
    const win = window.open('', '_blank');
    if (type === FileType.jpeg) {
        //FIXME: надо вернуть!
        const photo = ''; /* ReactDOMServer.renderToStaticMarkup(
            <div>
                <head>
                    <title>{filename}</title>
                </head>
                <p>
                    <b>{filename}</b>
                </p>
                <img
                    src={'data:image/jpg;base64,' + content}
                    alt={filename}
                    style={{margin: 3, maxWidth: 1920, maxHeight: 1080}}
                />
            </div>
        );*/
        if (win != null) {
            win.document.open();
            win.document.write(photo);
            win.document.close();
        }
        return;
    }
    if (win != null) {
        win.document.open();
        win.document.write(content);
        win.document.close();
    }
    return;
}
const inAppBrowserOpen = (content, filename) => {
    // without base64 it doesn't work on iOS
    const data_url = `data:${getFileType(filename)};base64,` +
        fromByteArray(new TextEncoderLite().encode(content));
    // @ts-ignore
    window.cordova.InAppBrowser.open(data_url, '_blank', 'location=no');
};
function downloadBrowser(content, filename) {
    console.log('content', content);
    const type = getFileType(filename);
    let changed_content = content;
    if (type === FileType.pdf || type === FileType.jpeg) {
        changed_content = toByteArray(content);
    }
    return downloadBlob(changed_content, filename, type, false);
}
async function downloadExcelBrowser(content, filename, api) {
    try {
        const blob = await api.convert_html_report_to_xlsx(content);
        return saveAs(blob, filename.replace('html', 'xlsx'));
    }
    catch (e) {
        console.error(e);
    }
    return;
}
// TODO: check is really work?
export function getDownloadActions() {
    switch (window.device?.platform ?? 'browser') {
        case 'Android':
            return [
                { title: 'открыть', action: openWithFileOpener, green_color: false },
                {
                    title: 'отправить',
                    action: shareWithSocialSharing,
                    green_color: true,
                },
            ];
        //     TODO: not work on iOS
        case 'iOS':
            return [
                { title: 'открыть', action: inAppBrowserOpen, green_color: false },
                {
                    title: 'отправить',
                    action: shareWithSocialSharing,
                    green_color: true,
                },
            ];
        default:
            return [
                { title: 'открыть', action: openInNewWindow, green_color: false },
                { title: 'скачать', action: downloadBrowser, green_color: true },
                {
                    title: 'скачать xlsx',
                    action: downloadExcelBrowser,
                    green_color: true,
                },
            ];
    }
}
